/* eslint-disable react/prop-types,no-underscore-dangle */
import { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Input from './Part/Input.jsx';
import iconUser from './icons/user.svg';
import iconPassword from './icons/lock.svg';
import { login } from '../services/axiosAuth';
import { login as loginAction } from '../reducers/authActions';
import Message from './Part/Message';
import Tooltip from '../components/Utils/Tooltip';

class LoginForm extends Component {
  state = {
    error: (this.props.location.state || {}).error,
    success: (this.props.location.state || {}).success,
    info: (this.props.location.state || {}).info,
    showMessage: false,
  };

  hideMessage = () => {
    this.setState({ showMessage: false });
  };

  submit = (values) => {
    login(values.username.trim(), values.password)
      .then((response) => {
        this.props.dispatch(loginAction(response.data.token));
        this.props.history.push('/');
      })
      .catch((e) => {
        if (e.response.status === 401) {
          this.setState({
            error: this.props.intl.formatMessage({ id: 'Invalid credentials' }),
            showMessage: true,
          });
        }
      });
  };

  render() {
    const validationSchema = Yup.object().shape({
      username: Yup.string().required(this.props.intl.formatMessage({ id: 'This field is required' })),
      password: Yup.string().required(this.props.intl.formatMessage({ id: 'This field is required' })),
    });
    return (
      <>
        {this.state.error && <Message message={this.state.error} open={this.state.showMessage} onClick={this.hideMessage} type='error' />}
        {this.state.success && (
          <Message message={this.state.success} open={this.state.showMessage} onClick={this.hideMessage} type='success' />
        )}
        {this.state.info && <Message message={this.state.info} open={this.state.showMessage} onClick={this.hideMessage} type='info' />}
        <Formik
          initialValues={{
            username: this.props.lastUsername,
            password: '',
          }}
          validateOnBlur
          validateOnChange
          validationSchema={validationSchema}
          onSubmit={this.submit}
          render={(props) => (
            <Form>
              <div className='field-box form-styles'>
                <Tooltip
                  placement='right'
                  message={this.props.intl.formatMessage({
                    id: 'At most login is your email address',
                  })}
                >
                  <label>
                    <FormattedMessage id='Login' />
                  </label>
                </Tooltip>
                <br />
                <Field
                  name='username'
                  component={Input}
                  value={props.values.username}
                  icon={iconUser}
                  onBlur={(v) => props.setFieldValue('username', v?.trim())}
                />
                <ErrorMessage component='div' className='text-danger' name='username' />
              </div>
              <div className='field-box form-styles'>
                <label>
                  <FormattedMessage id='Password' />
                </label>
                <br />
                <Field name='password' component={Input} type='password' value={props.values.password} icon={iconPassword} />
                <ErrorMessage component='div' className='text-danger' name='password' />
              </div>
              <Link className='login-link' to='/resetting'>
                <FormattedMessage id='Password resetting' />
              </Link>
              <div className='login-form-button-wrapper'>
                <button type='submit' className='login-form-button'>
                  <FormattedMessage id='SIGN IN' />
                </button>
              </div>
            </Form>
          )}
        />
      </>
    );
  }
}

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state.authReducer)
);

export default enhance(LoginForm);
